export var IDENTITY_PROVIDERS;
(function (IDENTITY_PROVIDERS) {
    IDENTITY_PROVIDERS["INFO_360"] = "Info360";
    IDENTITY_PROVIDERS["AUTODESK"] = "Autodesk";
    IDENTITY_PROVIDERS["BOTH"] = "Both";
})(IDENTITY_PROVIDERS || (IDENTITY_PROVIDERS = {}));
export var LOGIN_STATUS_ENUM;
(function (LOGIN_STATUS_ENUM) {
    LOGIN_STATUS_ENUM["AUTH_STAGE"] = "authStage";
    LOGIN_STATUS_ENUM["IDLE"] = "idle";
    LOGIN_STATUS_ENUM["PENDING"] = "pending";
    LOGIN_STATUS_ENUM["SUCCESS"] = "success";
    LOGIN_STATUS_ENUM["ERROR"] = "error";
})(LOGIN_STATUS_ENUM || (LOGIN_STATUS_ENUM = {}));
